import { createFileRoute } from "@tanstack/react-router";

import { PageHero } from "@/landing/system/blocks";
import { HeroCat } from "@/landing/system/cat";

export const Route = createFileRoute("/_landing/topup/success")({
  component: TopupSuccessPage,
  head: () => ({
    meta: [
      { title: "Credits added: Wonda" },
      {
        name: "description",
        content: "Your credits have been added to your account.",
      },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
});

// `wonda topup` sends its Stripe checkout back here.
function TopupSuccessPage() {
  return (
    <PageHero
      eyebrow="Top-up"
      title="Credits added."
      sub="Your balance is topped up. You can close this tab and go back to your agent."
      cta="none"
      visual={<HeroCat />}
    />
  );
}
